/**
 * Created by eritru on 2015-09-14.
 * Fonction javascrpt temporaire � d�placer dans le init et save du wizard une fois finalis�
 */

var mapCout;

function init_methode_cout() {


    var readOnly = $('#mode-read-only').val();
    if (readOnly == 'True') {
        controlesFormulaires.readOnlyFormulaire();
    }

    controlesFormulaires.detecterChangementsFormulaire();


    if ($('#current-id-batiment').val() != '') {
        $("#s2id_sommaire-select-no-batiment").select2("val", $('#current-id-batiment').val());
    }

    //var divPhoto = $('#sommaire-photo');
    //ajusterTailleImage(divPhoto.find('img'), '100px', '80px');
    initAceThumbnails('colorbox-photo-sommaire');
    initAceThumbnails('colorbox-photo-facteur-rajustement');
    initAceThumbnails('colorbox-photo-depreciation-normale');
    initAceThumbnails('colorbox-photo-depreciation-add');

    //var divCroquis = $('#sommaire-croquis');
    //ajusterTailleImage(divCroquis.find('img'), '100px', '80px');
    //initAceThumbnails('colorbox-croquis');

    $('#collapsible').on('shown.bs.collapse hidden.bs.collapse',
        function () {
            fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'), '#contenu');
            initMapAndAppendMethCoutSommaire()
        }
    );

    $('[name=baremeFacteurClasseManuelle]').on('change', function (e) {
        var tdFacteur = $(this).closest('td').next();

        var selOption = $(this).find(":selected");
        var facteur = selOption.attr('facteur');
        tdFacteur.html(facteur);
    });

    $("#btn-sommaire-sauvegarder").off("click").on("click", function () {
        sauvegarder_sommaire();
    });

    $("#btn-sommaire-imprimer").off("click").on("click", function () {
        imprimer_sommaire_methode_cout(false);
    });

    $("#btn-sommaire-imprimer-indicateurs").off("click").on("click", function() {
        imprimer_sommaire_methode_cout(true);
    });

    initRemarqueDepreciationsAdditionnelles();

    fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
    initFiltresSousOngletsMethodeCout();

    $('#tab-deprecie-norm-link').on('shown.bs.tab', function(){
        $(".textarea-auto-height-cout").each(function () {
            textarea_auto_height(this);
        });
        $(".textarea-auto-height-cout").on('change click', function(){
            textarea_auto_height(this);
        });
    })

}

function textarea_auto_height(elem_textarea){
    $(elem_textarea).css("height", `${elem_textarea.scrollHeight + 5}px`);
}

function imprimer_sommaire_methode_cout(avec_indicateurs) {
    $('#export-pdf-sommaire-avec-indicateur').val(avec_indicateurs);
    $('#export-pdf-sommaire-unites-evaluation').val(JSON.stringify([$('#id-ue').val()]));
    $('#export-pdf-sommaire-date-evenement').val(JSON.stringify($('#date-evenement').val()));
    $('#export-pdf-sommaire-type-batiment').val($('#current-id-type-batiment').val());
    $("#frm-export-pdf-sommaire").submit();
}

function get_excel_detail_cout_base_1997(exporterTousBatiments, idBatiment, typeBatiment, dateEvenement, idEvenement, idUe) {
    wait.start();
    const url = "/gestion-roles/methode-cout/export-xls-methode-cout/"
    const params = {
        'exporter_tous_batiments': exporterTousBatiments,
        'id_batiment': idBatiment,
        'type_batiment': typeBatiment,
        'date_evenement': dateEvenement,
        'id_evenement': idEvenement,
        'id_ue': idUe
    };

    const success = function (response) {
        infos.ajouterMessageToast({
            message: response,
            messageDuree: 3000,
        });
    }

    const error = function () {
        infos.ajouterMessageToast({
            message: 'Une erreur est survenue lors de l\'exportation de la Méthode du coût',
            messageCouleur: "red",
            messageDuree: 0
        });
    }

    call_ajax(url, 'GET', params, success, error);

}

function initFiltresSousOngletsMethodeCout(){
    $("#sommaire-select-type-batiment").select2();
    $("#sommaire-select-no-batiment").select2();

    $('#sommaire-select-type-batiment').on('change', function () {
        wait.start();

        if ($(this).val() != '') {
            var currentDateEvenement;
            var idUe;
            if ($('#wizard').length) {
                idUe = $('#wizard').attr('id-ue');
                currentDateEvenement = $('#wizard').attr('date-evenement');
            } else {
                idUe = $('#id-ue').val();
                currentDateEvenement = $('#date-evenement').val();
            }

            var currentIdBatiment = 0;
            var idTypeBatiment = $(this).val();

            // On charge les batiments par type de batiment
            $('#sommaire-select-no-batiment').find('option').remove().end();
            var url = "/gestion-roles/methode-cout/b93-evimbec-type-batiment/unite-evaluation/" + idUe + "/date/" + encodeURI(currentDateEvenement) + "/id-type-batiment/" + idTypeBatiment + "/";

            $.ajax({
                type: "GET",
                url: url,
                dataType: 'json',
                async: true,
                success: function (response) {

                    $('#sommaire-select-no-batiment').append($('<option>', {
                        value: null,
                        text: ""
                    }));

                    //On obtiens le résultats de la requet en format json
                    $.each(response, function (i, listNoBatiment) {

                        $('#sommaire-select-no-batiment').append($('<option>', {
                            value: listNoBatiment.id_batiment,
                            text: listNoBatiment.no_batiment
                        }));
                    });

                    $('#sommaire-select-no-batiment').select2("val", $('#sommaire-select-no-batiment').attr('data-placeholder').toString());

                    $('#current-id-type-batiment').val(idTypeBatiment);

                    $('#sommaire-onglet-div').empty();
                    get_onglet_sommaire(idUe, currentIdBatiment, currentDateEvenement, idTypeBatiment, 1);

                }
            });

        }

    });
    $("#sommaire-select-no-batiment").on("change", function () {
        wait.start();
        // tab-sommaire on flush toute les tabs
        if ($(this).val() != '') {

            $('#sommaire-onglet-div').empty();

            var currentIdBatiment = $(this).val();
            var idTypeBatiment = $('#sommaire-select-type-batiment').val() || '0';
            var idUe;
            var currentDateEvenement;
            if ($('#wizard').length) {
                idUe = $('#wizard').attr('id-ue');
                currentDateEvenement = $('#wizard').attr('date-evenement');
            } else { // si on est dans l'éditeur de fiche
                idUe = $('#id-ue').val();
                currentDateEvenement = $('#date-evenement').val();
            }

            get_onglet_sommaire(idUe, currentIdBatiment, currentDateEvenement, idTypeBatiment, 1);


        }
    });

}

function initRemarqueDepreciationsAdditionnelles() {
    $('[name="desuetude_fonctionnelle"], [name="deterioration_physique"], [name="facteur_contributif_manuel"], [name="desuetude_externe_manuelle"]').on('change', function () {
        var remarque = $(this).closest('td').find('[name="remarque_' + $(this).attr('name') + '"]');
        if ($(this).val() == '') {
            remarque.val('');
            remarque.closest('div').hide();
        } else {
            remarque.closest('div').show();
        }
    });

        $('#modale-depreciation-additionnelle').on('show.bs.modal', function (event) {
            var modal_depr = $(this);
            var modal_depr_type = $(event.relatedTarget).data('modal-type');

            modal_depr.find('#modale-depreciation-additionnelle-sous-titre').text($(event.relatedTarget).data('modal-titre'));

            function fermeModaleDepreciationAdditionnelle(modal_depr){
                $(modal_depr).modal('hide');
                $('#depreciation-additionnelle-pourcentage').val('');
                $('#modale-depreciation-additionnelle-remarque').val('');
            }
            $('#modale-depreciation-additionnelle-annuler').off().on('click', function(e){
                fermeModaleDepreciationAdditionnelle(modal_depr);
            });
            $('#modale-depreciation-additionnelle-sauvegarder').off().on('click', function(e){
                $('#table-depreciation input[name="'+modal_depr_type+'"]').val(
                    $('#depreciation-additionnelle-pourcentage').val()
                ).change();
                $('#table-depreciation [name="remarque_'+modal_depr_type+'"]').val(
                    $('#modale-depreciation-additionnelle-remarque').val()
                ).change();
                fermeModaleDepreciationAdditionnelle(modal_depr);
            });
        });

        $('#modale-depreciation-normale-manuel').on('show.bs.modal', function (event) {
            var modal_depr = $(this);
            var original_relatedTarget = $(event.relatedTarget);
            modal_depr.original_relatedTarget = original_relatedTarget;
            var id_type_batiment = $(original_relatedTarget).data('id_type_batiment');


            var input_id_bareme_facteur = $(original_relatedTarget).parent().find("input[name='le_id_bareme_facteur_depreciation_normale']");
            var id_bareme_facteur_depreciation_normale_manuel = $(input_id_bareme_facteur).val();
            var id_bareme_facteur_depreciation_normale = $(input_id_bareme_facteur).attr('bareme-facteur-depreciation-normal');

            $('#listes_facteur_depreciation_normale').find('select').hide();
            var current_select = $('#listes_facteur_depreciation_normale').find('#liste_facteur_depreciation_normale_'+id_type_batiment);
            current_select.val('');
            current_select.show();

            // si le bareme manuel en cours est celui "par defaut", on ne veut pas pré sélectionner
            if(id_bareme_facteur_depreciation_normale_manuel && id_bareme_facteur_depreciation_normale != id_bareme_facteur_depreciation_normale_manuel ){
               current_select.val(id_bareme_facteur_depreciation_normale_manuel);
            }
            $('#modale-depreciation-normale-manuel-annuler').off().on('click', function(e){
                $(modal_depr).modal('hide');
                current_select.val('');
            });
            $('#modale-depreciation-normale-manuel-sauvegarder').off().on('click', function(e){
                var current_select_text = $(current_select).find('option:selected').text();
                $(modal_depr.original_relatedTarget).parent().find('.methode_depreciation_label').text(current_select_text);
                $(modal_depr.original_relatedTarget).parent().attr('title', current_select_text);

                if($(input_id_bareme_facteur).val() != current_select.val()){
                    $(input_id_bareme_facteur).val(''+current_select.val()+'');
                    // pour forcer un changement
                    $(input_id_bareme_facteur).change();
                }
                $(modal_depr).modal('hide');
            });
            // #15360 : fix la hauteur du corps de la modale
            $("#modale-depreciation-normale-manuel").find('.modal-body').css('height', '');
        });//modal #modale-depreciation-normale-manuel




}


function blocHistorik(btnHistorik) {
    wait.start();
    var currentIdBatiment = $('#current-id-batiment').val();
    var currentIdFormulaire = $('#current-id-formulaire').val();
    var nomBloc = btnHistorik.parents('.accordion-actions').find('.btn-historik-blocx').attr('data-nom-bloc');
    var idEvenement = btnHistorik.parents('li').data('id-evenement');
    var dateEvenement = btnHistorik.parents('li').find('a').text();
    var idbloc = btnHistorik.parents('.accordion-actions').find('.btn-historik-blocx').data('action');

    $.ajax({
        type: "GET",
        url: "/gestion-roles/editeur-fiche/form_bloc/" + currentIdBatiment + "/" + currentIdFormulaire + "/" + nomBloc + "/"+idEvenement+"/",
        dataType: 'html',
        success: function (response) {

            // enlever le précédent bloc historique si présent...
            $('div#'+nomBloc).remove();
            // injecter la réponse au bloc suivant
            $('#' + nomBloc).after(response);

            // adapter le header du bloc
            $('div#'+nomBloc).find('.panel-title').append('- historique en date du '+dateEvenement);
            $('div#'+nomBloc).find('h4').addClass('bloc-historique-fond-barre');

            //  bouton fermeture
            $('div#'+nomBloc).find('.panel-heading').append('<div class="accordion-actions fiche-r-bloc align-right"><a id="'+nomBloc+'-bloc-close" data-action="close" href="#!"><i class="ace-icon fa fa-lg fa-close"></i></a></div>');

            // son callback
            $('#' + nomBloc + '-bloc-close').on('click', function () {
                $('div#'+nomBloc).slideUp(300, function () {
                    $('div#'+nomBloc).remove();
                });
            });

            $('html, body').animate({
                scrollTop: ($('div#' + nomBloc).offset().top - 250)
            }, 700);
            wait.stop();

            if(idbloc=='05'){
                initBlocsCharges(currentIdFormulaire, idbloc)
            }
        }
    });

}

// lorsqu'on clique le dollar au-dessus d'un bloc
function blocCoutClicked(btnCout) {
    var idWait = btnCout.closest('.panel-default').find('.panel-collapse').attr('id');

    var idBloc = btnCout.attr('data-action');
    var nomBloc = btnCout.attr('data-nom-bloc');
    var currentIdBatiment = $('#current-id-batiment').val();
    var currentDateEvenement = $('#date-evenement').val();
    var currentIdFormulaire = $('#current-id-formulaire').val();
    var currentIdTypeBatiment = $('#current-id-type-batiment').val();
    if ($('#evenement-' + idBloc + '-toggle').hasClass('in')) {
        wait.start(idWait);
    } else {
        wait.start();
    }
    $('#accordion-evenement-bloc-' + idBloc + '-focus').remove(); // On efface le div -focus, au cas où on ne le ferme pas au préalable à ce clic.

    $.ajax({
        type: "POST",
        url: "/gestion-roles/methode-cout/id-formulaire/" + currentIdFormulaire + "/bloc/" + idBloc + "/id-batiment/" + currentIdBatiment + "/date/" + encodeURI(currentDateEvenement) + "/condense/0/",
        dataType: 'html',
        success: function (response) {
            $('#accordion-evenement-bloc-' + idBloc).remove();
            $('#' + nomBloc).append(response);
            $('#' + idBloc + '-bloc-close').on('click', function () {
                $('#accordion-evenement-bloc-' + idBloc).fadeTo(300, 0.00, function () {
                    $(this).slideUp(300, function () {
                        $(this).remove();
                        $('#accordion-evenement-bloc-' + idBloc + '-focus').remove();
                    });
                });
            });
            init_date_picker();
            if ($('#evenement-' + idBloc + '-toggle').hasClass('in')) {
                wait.stop(idWait);
            } else {
                wait.stop();
            }
            wait.stop(idWait);
            focusControle('#accordion-evenement-bloc-' + idBloc + '-focus', 5);
            $('html, body').animate({
                scrollTop: ($('#' + idWait + '-bloc').offset().top - 250)
            }, 700);
        }
    });
}


//sauvegarder

function sauvegarder_sommaire(callback) {
    wait.start();
    var idEvenement;
    var idUe;
    var dateEvenement;
    var dateChargee;
    if ($('#modal-wizard-evenement').length > 0) {
        // vu que la sauvegarde doit rafraîchir les données, mettre le bouton Suivant inactif
        $('#btn-wizard-suivant-terminer').prop("disabled", true);
        // vu que la sauvegarde doit rafraîchir les données, mettre le bouton Sauvegarder inactif
        $('button#btn-wizard-save').prop('disabled', true);

        idEvenement = $('#wizard').attr('id-evenement');
        idUe = $('#wizard').attr('id-ue');
        dateEvenement = $('#wizard').attr('date-evenement');
        dateChargee = $('#wizard').attr('date-chargee');
    }
    else {
        idEvenement = $('#id-evenement').val();
        idUe = $('#id-ue').val();
        dateEvenement = $('#date-evenement').val();
        dateChargee = $('input[name="date-chargee"]').val();
    }

    // Génère les tableaux en json
    var list_facteur_man = tableToJsonSommaire('table-facteur-manuel');
    var list_depreciation_add_man = tableToJsonSommaire('table-depreciation');

    // #14070 / #14075
    var list_depreciation_add_man_json = JSON.parse(list_depreciation_add_man);
    $(list_depreciation_add_man_json).each(function(idx,row){
        var le_input;
        if('id_bareme_facteur_depreciation_normale_manuel_anterieure' in row){
            // tané, supplantation de la logique initiale de tableToJsonSommaire & co
            le_input = $('#tr_depreciation_'+row['id_b93_cout_neuf']).find('td>input[name="le_id_bareme_facteur_depreciation_normale"]');
            list_depreciation_add_man_json[idx]['id_bareme_facteur_depreciation_normale_manuel'] = $(le_input).val();
            list_depreciation_add_man_json[idx]['id_bareme_facteur_depreciation_normale_manuel_anterieure'] = $(le_input).attr('valeur-anterieure');
            list_depreciation_add_man_json[idx]['id_bareme_facteur_depreciation_normale'] = $(le_input).attr('bareme-facteur-depreciation-normal');
       }
        if('desuetude_externe_manuelle_anterieure' in row){
            le_input = $('#tr_depreciation_'+row['id_b93_cout_neuf']).find('td>input[name="desuetude_externe_manuelle"]');
            list_depreciation_add_man_json[idx]['desuetude_externe_manuelle'] = $(le_input).val();
            list_depreciation_add_man_json[idx]['desuetude_externe_manuelle_anterieure'] = $(le_input).attr('valeur-anterieure');
            list_depreciation_add_man_json[idx]['facteur_desuetude_externe'] = $(le_input).attr('facteur-desuetude-externe');
            var le_input_remarque = $('#tr_depreciation_'+row['id_b93_cout_neuf']).find('input[name="remarque_desuetude_externe_manuelle"]');
            list_depreciation_add_man_json[idx]['remarque_desuetude_externe_manuelle'] = $(le_input_remarque).val();
            list_depreciation_add_man_json[idx]['remarque_desuetude_externe_manuelle_anterieure'] = $(le_input_remarque).attr('valeur-anterieure');
       }
    });
    list_depreciation_add_man = JSON.stringify(list_depreciation_add_man_json);
    // fin #14070 / #14075


    // Gestion des badges
    $('#error-tab-facteur-manuel').text('');
    $('#error-tab-deprecie-add').text('');

    var params = {
        'list_facteur_man': list_facteur_man,
        'list_depreciation_add_man': list_depreciation_add_man,
        'date_chargee': dateChargee,
        'modifie': $('#sommaire-onglet-div').attr('modifie') === 'True'
    };

    erreursAjax.effacerErreurChamps($('#sommaire-onglet-div'));

    var jqxhr = $.ajax({
            type: "POST",
            url: '/gestion-roles/methode-cout/b93-cout-save/' + idEvenement + '/',
            dataType: 'json',
            async: true, // Nécessaire pour s'assurer d'attendre le résultat de la sauvegarde/validation avant de passer à l'étape suivante
            data: params
        }
    );
    jqxhr
        .done(function (response) {
            if (response.etapeEnCours){
                    infos.ajouterMessageToast({
                        message: response.etapeEnCours,
                        messageDuree: 5000,
                        messageCouleur: "green"
                    });
                    wait.start();
                    $('#btn-wizard-recharger').click();
                    return;
                }
            var dateChargee = '';
            var errorTabFacteurManuel = 0;
            var errorTabDeprecieAdd = 0;
            var isNotError = true;
            $.each(response, function (i, facteurManuel) {
                // 14717 : Raffraichissement de l'étape dans le cas d'un calcul délégué à Celery

                if (!facteurManuel.id) {
                    $.each(facteurManuel, function (key, value) {
                        if (key == 'error_tab_facteur_manuel') errorTabFacteurManuel = value;
                        if (key == 'error_tab_deprecie_add') errorTabDeprecieAdd = value;
                        if (key == 'date_chargee') dateChargee = value;
                    });

                    return;
                }

                var arrId = facteurManuel.id.split('-');
                var tab = (arrId.length > 1 ? $('#tab-deprecie-add') : $('#tab-facteur-manuel'));

                var td = tab.find('td:contains("' + arrId[0] + '")');
                var currentForm = td.closest('tr');

                if (!(facteurManuel.status >= 200 && facteurManuel.status < 300)) {
                    erreursAjax.traiterErreurs(currentForm, {
                        'status': facteurManuel.status,
                        'responseText': facteurManuel.responseText
                    }, facteurManuel.statusText);
                    isNotError = false;
                    // #15961 : On affiche le message d'erreur au complet
                    $('#sommaire-onglet-div td .form-border-alert-danger').parent('td').css('white-space', 'break-spaces');
                }
            });

            // si pas d'erreur on recharge le contenu de la modale
            if (isNotError === true) {
                wait.start();

                if($('#methode-cout [data-type="cout-sommaire-evimbec"]').length){
                    // Fiche explorateur
                    // #18511: simule le click sur le lien de création de la modale, pour raffraichir son contenu.
                    $('#methode-cout [data-type="cout-sommaire-evimbec"]').click();
                }else{
                    // TAJ
                    $('#modal-step-contents > .active').attr('recharger','oui');
                }
                // changer 'date-chargee' dans le html pour la prochaine sauvegarde dans le sommaire
                $('input[name="date-chargee"]').val(dateChargee);

            } else {
                if (errorTabFacteurManuel != 0) $('#error-tab-facteur-manuel').text(errorTabFacteurManuel);
                if (errorTabDeprecieAdd != 0) $('#error-tab-deprecie-add').text(errorTabDeprecieAdd);
            }
            messageToastCompteur = 0;
            var nbErreurs = errorTabFacteurManuel + errorTabDeprecieAdd;
            sauvegarderDonneesMessageToast({}, 1, jqxhr, nbErreurs);
            if ($('#modal-wizard-evenement').length > 0) {
                $('button#btn-wizard-save').prop('disabled', true);
            } else {
                $('button#btn-sommaire-sauvegarder').prop('disabled', true);
            }
            if (typeof (callback) !== 'undefined') {
                var response = {};
                if (nbErreurs > 0) {
                    response.reponse = 'error';
                } else {
                    response.reponse = 'ok';
                }
                callback(response);
            }
            if ($('#modal-wizard-evenement').length > 0) {
                // vu que le rafraîchissement des données est long, remettre le bouton Suivant actif à la fin
                $('#btn-wizard-suivant-terminer').prop("disabled", false);
            }
            wait.stop();
        });
    jqxhr
        .fail(function (jqxhr, textStatus, errorThrown) {
            erreursAjax.traiterErreurs($('.contenu-principal'), jqxhr, errorThrown);

            messageToastCompteur = 0;
            sauvegarderDonneesMessageToast({}, 1, jqxhr, 1);
            if (typeof (callback) !== 'undefined') {
                var response = {};
                response.reponse = 'error';
                callback(response);
            }
            if ($('#modal-wizard-evenement').length > 0) {
                // vu que le rafraîchissement des données est long, remettre le bouton Suivant actif à la fin
                $('#btn-wizard-suivant-terminer').prop("disabled", false);
            }
            wait.stop();
        });
}

function get_totaux_sommaire(idUe, currentDateEvenement) {

    var url = "/gestion-roles/methode-cout/b93-evimbec-totaux/unite-evaluation/" + idUe + "/date/" + encodeURI(currentDateEvenement) + "/";
    $.ajax({
        type: "POST",
        url: url,
        dataType: 'html',
        success: function (response) {
            $('#sommaire-totaux-div').append(response);
        }
    });

}

function get_onglet_sommaire(idUe, currentIdBatiment, currentDateEvenement, idTypeBatiment, impression) {

    var url = "/gestion-roles/methode-cout/b93-evimbec-onglet/unite-evaluation/" + idUe + "/id-batiment/" + currentIdBatiment + "/date/" + encodeURI(currentDateEvenement) + "/id-type-batiment/" + idTypeBatiment + "/impression/" + impression + "/";
    $.ajax({
        type: "POST",
        url: url,
        dataType: 'html',
        success: function (response) {
            $('#sommaire-onglet-div').append(response);
            scroll.ajouterSlimScroll('#sommaire-onglet-div', {hauteur: 500});
            controlesFormulaires.detecterChangementsFormulaire();
            var readOnly = $('#mode-read-only').val();
            if (readOnly == 'True') {
                controlesFormulaires.readOnlyFormulaire();
            }
            initAceThumbnails('colorbox-photo-sommaire');
            initAceThumbnails('colorbox-photo-facteur-rajustement');
            initAceThumbnails('colorbox-photo-depreciation-normale');
            initAceThumbnails('colorbox-photo-depreciation-add');

            initRemarqueDepreciationsAdditionnelles();
            initFiltresSousOngletsMethodeCout();
            wait.stop();
        }
    });

}


function tableToJsonSommaire(table) {

    //2 premisse de base
    //Il faut mettre l'attribut data-name="" dans les th du tableau
    //Il faut mettre l'attribut data-value="" dans le td du tableau


    var columns = $('#' + table + ' thead th').map(function () {
        return $.trim($(this).data('name'));
        //return  $.trim($(this).text());
    });

    var tableObject = $('#' + table + ' tbody tr').map(function (i) {
        var row = {};
        $(this).find('td').each(function (i) {
            var rowName = columns[i];

            //On recupere la valeur de l'attribut' dataValue en fonction du type de control

            if ($(this).attr('dataValue') == 'input:text') {
                row[rowName] = $(this).find("input").val();
                row[rowName + '_anterieure'] = $(this).find("input").attr('valeur-anterieure');
                var divRemarque = $(this).find('div [name^="remarque_"]');
                if (divRemarque.length) {
                    row[divRemarque.attr('name')] = divRemarque.val();
                }
            }

            if ($(this).attr('dataValue') == 'val') {
                row[rowName] = $(this).text();
                row[rowName + '_anterieure'] = $(this).text();
            }

            if ($(this).attr('dataValue') == 'select') {
                row[rowName] = $(this).find("select").val();
                row[rowName + '_anterieure'] = $(this).find("select").attr('valeur-anterieure');
            }

            // introduit dans #14070
            if ($(this).attr('dataValue') == 'hidden') {
                row[rowName] = $(this).find("input:hidden").val();
                row[rowName + '_anterieure'] = $(this).find("input:hidden").attr('valeur-anterieure');
            }


        });
        return row;
    }).get();

    return JSON.stringify(tableObject);
}


function initMapAndAppendMethCoutSommaire() {
    if ($('#som-cout-ajouter-carte').hasClass('loaded'))return;

    $('#som-cout-ajouter-carte').addClass('loaded');

    $('#som-cout-ajouter-carte').empty().append('<div id="lsidebar"></div><div id="map-controls-cout" class="map-controls-container map-controls-container-alt"></div><div id="map-cout" class="leaflet-container-alt"> </div>');
    var hauteur = 480;
    $('#map-cout').css("height", hauteur + "px");

    getBboxMunicipalite($('#wizard').attr('id-municipalite'), function (bbox) {
        var idMap = getInfoMap($('#wizard').attr('id-municipalite'), 31)
        mapCout = new L.Map('map-cout', {center: new L.LatLng(45.5, -72.4), zoom: 16, maxZoom: 23});
        mapCout.EnableSelectFeatureByAttribute({
            url: '/gestion-roles/tenue-a-jour/operation-ue/unite-evaluation.json/',
            zoomToFeature: true,
            idMunicipalite: $('#wizard').attr('id-municipalite'),
            dateEvenement: $('#wizard').attr('date-evenement'),
            callbackBeforeSelect: function () {

            },
            callback: function (properties) {

            }
        });
        var baseMaps = getBaseMap('googleStreetsCout');
        var overlays = [{}];

        var options = {
            container_width: "250px",
            group_maxHeight: "200px",
            container_maxHeight: "600px"
        };
        var control = L.Control.styledLayerControl(baseMaps, overlays, options);
        mapCout.addControl(control);
        $("#map-controls-cout").append(control.getContainer());
        mapCout.addLayer(googleStreetsCout);
        var urlGeoserver = $('#urlGeoserver').val();
        var urlOrthosGeoserver = $('#urlOrthosGeoserver').val();
        mapCout = mapCout.buildEvbMap({
            idMap: idMap,
            zoomToMapExtent: true,
            controlLayers: control,
            urlGeoserver: urlGeoserver,
            urlOrthosGeoserver: urlOrthosGeoserver,
            idMunicipalite: $('#wizard').attr('id-municipalite'),
            bbox: bbox,
            dateEvenement: $('#wizard').attr('date-evenement'),
            callback: function () {
                mapCout.selectFeatureByAttribute($('#wizard').attr('matricule'), true, true, $('#wizard').attr('id-ue'));

            }
        });

        mapCout.whenReady(function() {
            init_layer_group_checkbox_and_layer_menu_styles();
        });
    })
};
